import styled from 'styled-components';

export const LogoImage = styled.img`
  /* padding: 20px; */
  max-width: ${(props) => props.logoWidth || '215px'};
  margin: auto;
`;
